const env = window.env || {};
export const baseUrlBackend = (env.REACT_APP_API_URL|| "http://localhost:8000") + (env.REACT_APP_API_PREFIX|| "") ;